import 'whatwg-fetch';
import 'promise-polyfill/src/polyfill';
import './styles/familyFirst.scss';
import React from 'react';
import ReactDOM from 'react-dom';
import Modal from 'react-modal';
import App from './src/App';

Modal.setAppElement('#model-selector');

ReactDOM.render(<App />, document.getElementById('model-selector'));
